import { IComboBox, IComboBoxOption } from "@fluentui/react";
import React, { useCallback, useEffect, useRef, useState } from "react";
import personaServicio from "../../services/persona/personaServicio";
import { useAbortController } from "../../pages/gestionDocumentos/hooks/useAbortController";
import { IItemComboBaseDTO } from "../../Interfaces/base/IBase";
import EquipoTrabajoRol from "../../services/administracion/EquipoTrabajoRol/EquipoTrabajoRol";
import { Ifilter } from "../../Interfaces/filter";
import EquipoModeloService from "../../services/ListaVerificacion/EquipoModeloService";
import { Equipo } from "../../pages/auxiliar/equipos/Equipo";
import EquipoTrabajoRolService from "../../services/administracion/EquipoTrabajoRol/EquipoTrabajoRol";

export interface IComboBoxPer extends IComboBox {
  text: string;
  key: string;
  descripcion?: string;
  disabled?: boolean;
  codigo?: string;
  foto?:string
}


export const useComboEquipoTrabajoRol = () => {
  const { handleAbortController } = useAbortController();
  const [filter, setFilter] = useState<Ifilter>({ 
    search: "",
    skip: 0,
    take: 10
   });
  const [dataComboEquipoTrabajoRol, setDataComboEquipoTrabajoRol] = useState<IComboBoxPer[]>(
    []
  );

  const comboBoxRefEquipoTrabajoRol = useRef<IComboBoxPer>(null);
  
  const _openOptionEquipoTrabajoRol = useCallback(
    () => comboBoxRefEquipoTrabajoRol.current?.focus(true),
    []
  );

  const onClickComboEquipoTrabajoRol = () => comboBoxRefEquipoTrabajoRol.current?.focus(true);

  const _onkeyUpSearchEquipoTrabajoRol = (event: React.KeyboardEvent<IComboBoxPer>) => {
    if (event.code === "Escape") {
      comboBoxRefEquipoTrabajoRol.current?.focus(false);
      setFilter(
        {
          search: "",
          skip: 0,
          take: 10
        }
      );
    } else {
      _openOptionEquipoTrabajoRol();
      let { value } = event?.target as HTMLInputElement;
      setFilter({ 
        search: value,
        skip: 0,
        take: 50
       });
    }
  };

  const listarCombo = () => {
    EquipoTrabajoRolService.comboEquipoTrabajoRol(filter, handleAbortController()).then((res) => {
      if (res.status === 200) {
        setDataComboEquipoTrabajoRol(res.data);
      }
    }).catch((e) => {
      console.error(e.message);
    });
  };

  const limpiarFilters = () => {
    setFilter({ 
      search: "",
      skip: 0,
      take: 50
    });
  };

  useEffect(() => {
    listarCombo();
  }, [filter]);

  return {
    dataComboEquipoTrabajoRol,
    onClickComboEquipoTrabajoRol,
    _onkeyUpSearchEquipoTrabajoRol,
    comboBoxRefEquipoTrabajoRol,
    limpiarFilters,
  };
};

